/* eslint-disable no-param-reassign,no-console */
import { createAction, createReducer } from "@reduxjs/toolkit"
import httpClient from "../../api/httpClient"
import appStore from "../../appStore"
import { models } from "./pages"

const fetchAuthorizedPageResult = createAction("wealth/fetchAuthorizedPage")
const clear = createAction("wealth/clear")

function fetchAuthorizedPage() {
  return async (dispatch, getState) => {
    const { locale } = getState().intl
    const queryParams = new URLSearchParams({ locale }).toString()
    const { data } = await httpClient.get(`/api/wealth?${queryParams}`)

    function pageIsValid(page) {
      if (!page.pageIdentifier) {
        console.error(
          `Found invalid page identifier "${page.pageIdentifier}" for page`,
          page
        )
        return false
      }

      if (!models[page.pageIdentifier]) {
        console.error(
          `Could not find static page model for page with identifier "${page.pageIdentifier}"`
        )
        return false
      }

      return true
    }

    // make a merge with default value
    // config can be partially set, and create some "bug"
    const authorizedPageDef = data.pages.filter(pageIsValid).map((pageDef) => ({
      // This order is significant
      ...models[pageDef.pageIdentifier],
      ...pageDef
    }))

    dispatch(
      fetchAuthorizedPageResult({
        pages: authorizedPageDef
      })
    )
  }
}

const initialState = {
  pages: undefined
}

/**
 * New reducer instance for pages configuration
 */
const reducer = createReducer(initialState, {
  "wealth/fetchAuthorizedPage": (state, { payload }) => {
    // payload contains map of pages configuration
    // see initial state data structure
    state.pages = payload.pages
  },
  "wealth/clear": () => initialState
})

appStore.injectReducer("wealth", reducer)

/**
 * Reset state when language change because some translations can be stored in backend
 */
function onChangeLanguageListener() {
  let currentLanguage = "fr"
  appStore.subscribe(() => {
    const { intl } = appStore.getState()
    if (intl.locale === currentLanguage) {
      return
    }
    // update var & cleanup state
    currentLanguage = intl.locale
    appStore.dispatch(clear())
  })
}

// eval listener registration, only when loading current slice
onChangeLanguageListener()

export default { actions: { fetchAuthorizedPage, clear } }
